<template>
    <div class="rightGather" ref="rightGather" v-if="$mapStep.type!='shopActive'">
        <!--快捷推荐-->
        <QuickModule
            v-show="$mapStep.type !='toFilter' &&
            $mapStep.type!='selectePOI' && !$mapStep.poiID &&
            $mapStep.type!='poiDetail' && $mapStep.type !='planRoute' &&
            $mapStep.type !='toPlanRoute' && $mapStep.type != 'toNAVING' && !$BRT.$urlParam.share.status"></QuickModule>
    </div>
</template>

<script>

    import QuickModule from "./modules/QuickModule.vue";
    export default {
        name: "RightGather",
        components: {QuickModule}
    }
</script>

<style scoped>

</style>
